import React, { useEffect } from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';
import { InputLabelContainer } from '../../../../common/components/form/label/containers/input-label.container';
import { selectListItems } from '../../../../redux/library/selector';
import { useAppSelector } from '../../../../hooks/hooks';
import { HiOutlineTrash } from 'react-icons/hi';
import _ from 'lodash';
import { getSelectedOptionLabel, getSelectedOptionValue } from '../../../../common/services/common.service';

export const GlobalParsingRuleBasicInfoComponent = ({ deleteSelectedService, fieldConversions, handleInnerBasicFormChange, handleInnerFormChange, parsingRule, tenantFunctions, handleFormItemChange }: any) => {
  const libraryData = useAppSelector(selectListItems)
  
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              labelField="Name"
              onValueChange={(event: any, newValue: any) => {
                handleInnerBasicFormChange(
                  event.target.value,
                  'Name',
                );
              }}
              type="text"
              value={parsingRule?.Name}
            />

            <InputContainer
              label="Owner Type"
              labelField="FunctionName"
              list={tenantFunctions}
              onValueChange={(event: any, newValue: any) => {
                handleInnerBasicFormChange(
                  event.target.value,
                  'OwnerType',
                );
              }}
              optionName='Choose Owner Type Name'
              type="select"
              value={parsingRule?.OwnerType}
              valueField="FunctionName"
            />            
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Information"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Input File Type "
              labelField="Text"
              list={libraryData?.result?.FileFormatType}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'Options.InputFileType'
                });
              }}
              optionName='Choose Input FileType'
              type="select"
              value={parsingRule?.Options?.InputFileType}
              valueField="Text"
            />

            <InputContainer
              label="Output File Type "
              labelField="Text"
              list={libraryData?.result?.FileFormatType}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'Options.OutputFileType'
                });
              }}
              optionName='Choose Output FileType'
              type="select"
              value={parsingRule?.Options?.OutputFileType}
              valueField="Text"
            />

            <InputContainer
              label="Input File Has Header"
              labelField="InputFileHasHeader"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event,
                  path: 'Options.InputFileHasHeader'
                });
              }}
              type="checkbox"
              value={parsingRule?.Options?.InputFileHasHeader}
            />

            <InputContainer
              label="Output File Has Header"
              labelField="OutputFileHasHeader"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event,
                  path: 'Options.OutputFileHasHeader'
                });
              }}
              type="checkbox"
              value={parsingRule?.Options?.OutputFileHasHeader}
            />
          </div>
        }
        expandedPanel="Options"
        headerTitle="Options"
      />
      <AccordionContainer
        child={
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300">
              <thead>
                <tr>
                  <th className="px-4 py-2 border-b border-gray-300">Delete</th>
                  <th className="px-4 py-2 border-b border-gray-300">INPUTFIELD INDEX</th>
                  <th className="px-4 py-2 border-b border-gray-300">INPUTFIELD TYPE</th>
                  <th className="px-4 py-2 border-b border-gray-300">OUTPUTFIELD INDEX</th>
                  <th className="px-4 py-2 border-b border-gray-300">OUTPUTFIELD TYPE</th>
                  <th className="px-4 py-2 border-b border-gray-300">OUTPUTHEADER TEXT</th>
                </tr>
              </thead>
              <tbody>
                {_.map(fieldConversions, (cardValue, index) => (                  
                  <tr key={index} className="h-20">
                    <td className="px-4 py-2 border-b border-gray-300">
                      <button className="text-red-500 hover:text-red-700" onClick={async () => deleteSelectedService(cardValue, index)}>
                        <HiOutlineTrash className="w-6 h-6" />
                      </button>
                    </td>
                    <td className="px-4 py-2 border-b border-gray-300">
                      <InputContainer
                      labelField="InputField Index"
                      readOnly={true}
                      onValueChange={(event: any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'InputFieldIndex',
                          idx: index,
                        });
                      }}
                      type="number"
                      value={cardValue?.InputFieldIndex || index + 1}
                    /></td>
                    <td className="px-4 py-2 border-b border-gray-300">
                      <InputContainer
                        labelField="Text"
                        list={libraryData?.result?.FilterDataType}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: getSelectedOptionLabel(libraryData?.result?.FilterDataType, "Description","Value", event.target.value),
                            field: 'InputFieldType',
                            idx: index,
                          });
                        }}                        
                        optionName="Choose Field Type"
                        type="select"
                        value={getSelectedOptionValue(libraryData?.result?.FilterDataType, "Description","Value", cardValue?.InputFieldType)}
                        valueField="Value"
                      />
                    </td>
                    <td className="px-4 py-2 border-b border-gray-300"> <InputContainer
                      labelField="Output Field Index"
                      readOnly={true}
                      onValueChange={(event: any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'OutputFieldIndex',
                          idx: index,
                        });
                      }}
                      type="text"
                      value={cardValue?.OutputFieldIndex || index + 1}
                    /></td>
                    <td className="px-4 py-2 border-b border-gray-300">
                      <InputContainer
                        labelField="Text"
                        list={libraryData?.result?.FilterDataType}
                        onValueChange={(event: any, newValue: any) => {
                          handleFormItemChange({
                            value: getSelectedOptionLabel(libraryData?.result?.FilterDataType, "Description","Value", event.target.value),
                            field: 'OutputFieldType',
                            idx: index,
                          });
                        }}
                        optionName="Choose Field Type"
                        type="select"
                        value={getSelectedOptionValue(libraryData?.result?.FilterDataType, "Description","Value", cardValue?.OutputFieldType)}
                        valueField="Value"
                      />
                    </td>
                    <td className="px-4 py-2 border-b border-gray-300">
                      <InputContainer
                        labelField="OutputHeaderText"
                        onValueChange={(event: any) => {
                          handleFormItemChange({
                            value: event.target.value,
                            field: 'OutputHeaderText',
                            idx: index,
                          });
                        }}
                        type="text"
                        value={cardValue?.OutputHeaderText}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        }
        expandedPanel="Field Conversions"
        headerTitle="Field Conversions"
      />
    </>
  )
}
export default GlobalParsingRuleBasicInfoComponent;
